// Material Kit 2 React pages
import QuestionPapers from "pages/ElearningAndQuestionPapers/QuestionPapers";

export default function QuestionPaperPage() {
  return <QuestionPapers />;
}
